import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPreviewTitleChangeResponse } from './preview-title-change-response';
import { previewTitleChangeResponseSchema } from './preview-title-change-response';

export async function previewTitleChangeApi(
  challengeId: number,
  title: string,
): Promise<IValidatedResponse<IPreviewTitleChangeResponse>> {
  return postRequest<IPreviewTitleChangeResponse>({
    path: `/sys/challenges/${challengeId}/preview-title`,
    body: { title },
    schema: previewTitleChangeResponseSchema,
  });
}
